import { useState } from "react"
import { X } from "@phosphor-icons/react"
import { t } from "i18next"
import { ScrollWrapper } from "@/components/scroll-wrapper.tsx"
import { Button } from "@/components/ui/button.tsx"
import { Dialog, DialogContentCustom, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog.tsx"
import { Input } from "@/components/ui/input.tsx"
import { usePatientParam } from "@/modules/patients/hooks/usePatientParam"
import { useChPatientUpdateCaveMutation } from "@/modules/patients/services/ch/useChPatientUpdateCave.ts"
import { useDePatientUpdateCaveMutation } from "@/modules/patients/services/de/useDePatientUpdateCave.ts"

const CaveDialog = ({
  open,
  closeDialog,
  message,
  country,
}: {
  open: boolean
  closeDialog: () => void
  message: string | null | undefined
  country: string
}) => {
  const patientId = usePatientParam()
  const updateChCave = useChPatientUpdateCaveMutation()
  const updateDeCave = useDePatientUpdateCaveMutation()
  const [caveMessage, setCaveMessage] = useState(message)

  const onUpdateCave = () => {
    if (country === "CH") {
      updateChCave(
        {
          patientId,
          message: caveMessage,
        },
        closeDialog,
      )
    }
    if (country === "DE") {
      updateDeCave(
        {
          patientId,
          message: caveMessage,
        },
        closeDialog,
      )
    }
  }

  return (
    <Dialog open={open} onOpenChange={closeDialog}>
      <DialogContentCustom className="flex h-62.5 max-w-131 min-w-130 flex-col gap-0 p-0">
        <DialogHeader>
          <DialogTitle data-testid="cave-dialog-title">{t("patient.information.cave")}</DialogTitle>
        </DialogHeader>
        <div className="flex flex-1 overflow-hidden">
          <ScrollWrapper className="h-[100] px-6 py-4">
            <Input
              testId="cave-input"
              label={t("patient.information.cave")}
              value={caveMessage as string}
              onChange={(e) => setCaveMessage(e.target.value)}
              maxLength={500}
            />

            {caveMessage && (
              <span className="hover:bg-surface-hovered visible absolute top-26.25 right-8 z-50 -translate-y-1/2 cursor-pointer rounded-full p-1 transition-all">
                <X className="text-on-surface-subdued h-6 w-6 cursor-pointer" onClick={() => setCaveMessage("")} />
              </span>
            )}
          </ScrollWrapper>
        </div>
        <DialogFooter data-testid="cave-dialog-footer">
          <Button type="button" variant="secondary" onClick={closeDialog}>
            {t("common.button.close")}
          </Button>
          <Button data-testid="close-patient-info-btn" onClick={onUpdateCave}>
            {t("common.button.save")}
          </Button>
        </DialogFooter>
      </DialogContentCustom>
    </Dialog>
  )
}

export { CaveDialog }
